import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectNewClientLabel = (store: StoreSchema) => store.newClientLabel.clientLabel
